import $http, { genericHttp } from '../../shared/http';

export const fundraisings = {
  namespaced: true,

  actions: {
    async LOAD_FUNDRAISING_DATA(ctx, { orgId, id }) {
      if (!orgId) {
        throw new Error('Church ID not provided');
      }
      return $http('v2').get(`organisations/${orgId}/fundraisings/${id}`);
    },
    async CREATE_EDIT_FUNDRAISING_ACTION(ctx, { url, form, method }) {
      const formData = new FormData();
      for (const field in form) {
        if (Object.hasOwnProperty.call(form, field)) {
          const fieldValue = form[field];

          if (field === 'files' && Array.isArray(fieldValue) && fieldValue.length > 0) {
            for (const file of fieldValue) {
              if (!file) {
                continue;
              }
              formData.append('files[]', file);
            }
          } else if (fieldValue !== undefined && fieldValue !== null) {
            formData.append(field, fieldValue);
          }
        }
      }

      return genericHttp({ url, method, data: formData, isMultipartData: true });
    },
  },
};
